import { useQuery } from "@tanstack/react-query";
import { AppointmentService } from "../services/AppointmentService";
export function useSlotsQuery(params) {
    const { workspaceId, addressId, doctorId, date, slotFetchMode, invalidationKey, patientTimezone, durationMins, mode, followUp = false, patientCountryCode = null, } = params;
    return useQuery({
        queryKey: [
            "medos",
            "slots",
            workspaceId,
            addressId,
            doctorId,
            date,
            slotFetchMode,
            invalidationKey,
            patientTimezone ?? null,
            durationMins ?? null,
            mode ?? null,
            followUp,
            patientCountryCode,
        ],
        queryFn: () => slotFetchMode === "qms"
            ? AppointmentService.fetchQmsSchedule(workspaceId, addressId, doctorId, date).then(({ slots, domesticCurrency }) => ({
                slots,
                availableDurations: [],
                allSessionPackResponses: [],
                plans: [],
                activeSessionPackResponses: [],
                queueCurrency: domesticCurrency,
            }))
            :
                AppointmentService.fetchSlotsWithPacks(workspaceId, addressId, doctorId, date, patientTimezone, followUp ? null : durationMins, mode, followUp, patientCountryCode),
        enabled: !!(workspaceId && addressId && doctorId && date),
        staleTime: 0,
        gcTime: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: 0,
    });
}
